/**
 * Convert spreadsheet data to an array
 * see https://gist.github.com/torjusb/7d6baf4b68370b4ef42f for more info
 * and https://stackoverflow.com/questions/281264/remove-empty-elements-from-an-array-in-javascript for how the filter works
 * @param event
 * @returns
 */
const spreadsheetToArray = (spreadsheetData: string) => {
    const doubleQuoteRegex = /^"|"$/g;
    const tabRegex = /\t/g;
    const newlineRegex = /\r\n|\n\r|\n|\r/g;

    const dupedArray = spreadsheetData
        .replace(tabRegex, "\n")
        .split(newlineRegex)
        .map(item => item.replace(doubleQuoteRegex, "")) // handle pastes of multiline cells
        .filter(item => item.length);

    return [...new Set(dupedArray)];
};

/**
 * Determine if a paste is from a spreadsheet and allow to be handled
 * @param event
 * @param handleChange
 * @param props
 * @returns
 */

const extractValuesFromSpreadsheet = event => {
    event.preventDefault();
    const clipboardData =
        event.clipboardData || (event.originalEvent && event.originalEvent.clipboardData);
    const pastedText = clipboardData.getData("Text") || clipboardData.getData("text/plain");

    let values = [];
    if (pastedText?.length) {
        values = spreadsheetToArray(pastedText);
    }

    return values;
};

export const handleSpreadSheetPaste = (event, handleChange, handleSpreadsheetValues) => {
    const values = extractValuesFromSpreadsheet(event);
    if (values.length > 1) {
        handleSpreadsheetValues?.({ values, handleChange });
    } else if (values.length === 1) {

        if (handleChange) {
            handleChange({ target: { value: values[0] } });
        }
    }
};

export interface spreadSheetProps {
    values: string[];
    handleChange?: (e?: any) => void;
}
